import React, { Component } from "react";
import "./courseHero.css";
import handleValidation from "../../../Validation";

import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label
} from "reactstrap";
import { Link } from "react-router-dom";

class CourseHero extends Component {
  constructor() {
    super();
    this.state = {
      firstName: "",
      email: "",
      phoneNumber: ""
    };
  }

  submitDetails = event => {
    debugger;
    let formData = {
      first_name: this.refs.first_name.value,
      email: this.refs.email.value,
      contact: this.refs.contact.value
    };
    let errors = handleValidation(formData);
    this.setState({ errors: errors });
    if (errors["valid"] == true) {
      document.getElementById("req-syllabus").action =
        "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8";
      document.getElementById("req-syllabus").method = "POST";
    } else {
      this.setState({ errorsdiv: true });
      event.preventDefault();
    }
  };

  toggle = () => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  };

  render() {
    return (
      <div className={this.props.cName}>
        <Container>
          <Row className="justify-content-start mt-lg-3">
            <Col sm={{ size: 12 }} lg={{ size: 12, offset: 1 }}>
              <h1 className="course-header">
                {this.props.courseName} {this.props.courseType}
              </h1>
              <h4 className="hero-path pt-3 ">
                {" "}
                {this.props.courseHours} {this.props.courseType}
              </h4>
              <div className="pt-4 pb-5 mb-lg-5">
                <Row className="justify-content-center justify-content-sm-start">
                  <Col
                    xs={{ size: 6 }}
                    sm={{ size: "auto" }}
                    className="text-center"
                  >
                    <Link to="/apply-now">
                      <Button className="course-hero-start1 ">
                        Start Application
                      </Button>
                    </Link>
                  </Col>
                  <Col
                    xs={{ size: 6 }}
                    sm={{ size: 3 }}
                    className="text-center w-100"
                  >
                    <Button
                      className="course-hero-apply1"
                      onClick={this.toggle}
                    >
                      Request Syllabus
                    </Button>
                  </Col>
                </Row>

                <Modal
                  isOpen={this.state.modal}
                  toggle={this.toggle}
                  className={this.props.className}
                >
                  <ModalHeader toggle={this.toggle}>
                    Request Syllabus
                  </ModalHeader>
                  <form
                    action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
                    method="POST"
                    onSubmit={this.submitDetails.bind(this)}
                  >
                    <input type="hidden" name="oid" value="00D3i000000GUvA" />
                    <input type="hidden" name="lead_source" value="Website" />
                    <input
                      type="hidden"
                      name="00N3i00000Bm5C9"
                      value={this.props.webSource}
                    />

                    <input
                      type="hidden"
                      name="retURL"
                      value="https://atlighthouse.com/thank-you"
                    />
                    <ModalBody>
                      <Row>
                        <Col sm={{ size: 12 }}>
                          <FormGroup>
                            <Label for="exampleName">Full Name</Label>
                            <input
                              id="first_name"
                              maxLength="40"
                              name="first_name"
                              size="20"
                              type="text"
                              className="apply-now-inputs form-control"
                              ref="first_name"
                              placeholder="First Name"
                            />
                            {this.state.errorsdiv === true ? (
                              <span className="error">
                                {this.state.errors["first_name"]}
                              </span>
                            ) : (
                              ""
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={{ size: 12 }}>
                          <FormGroup>
                            <Label for="exampleEmail">Email</Label>
                            <input
                              id="email"
                              maxLength="80"
                              name="email"
                              size="20"
                              type="email"
                              className="apply-now-inputs form-control"
                              ref="email"
                              placeholder="Email"
                            />
                            {this.state.errorsdiv === true ? (
                              <span className="error">
                                {this.state.errors["email"]}
                              </span>
                            ) : (
                              ""
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={{ size: 12 }}>
                          <FormGroup>
                            <Label for="examplePhoneNumber">Phone Number</Label>
                            <input
                              id="contact"
                              maxLength="40"
                              minLength="10"
                              name="phone"
                              size="20"
                              type="text"
                              className="apply-now-inputs form-control"
                              ref="contact"
                              placeholder="Phone Number"
                            />
                            {this.state.errorsdiv === true ? (
                              <span className="error">
                                {this.state.errors["contact"]}
                              </span>
                            ) : (
                              ""
                            )}
                          </FormGroup>
                        </Col>
                      </Row>

                      <input
                        type="submit"
                        name="submit"
                        className="courses-button btn btn-secondary"
                      />
                    </ModalBody>
                  </form>
                  <ModalFooter>
                    <Row>
                      <Col sm={{ size: 12 }}>
                        <p>
                          <i style={{ color: "black" }}>
                            By providing your email, you agree to our{" "}
                            <u>
                              <Link
                                style={{ color: "black" }}
                                to="/privacy-policy"
                              >
                                privacy policy
                              </Link>
                            </u>{" "}
                            and{" "}
                            <u>
                              <Link
                                style={{ color: "black" }}
                                to="/terms-and-conditions"
                              >
                                terms and conditions
                              </Link>
                            </u>
                          </i>
                          .
                        </p>
                      </Col>
                    </Row>
                  </ModalFooter>
                </Modal>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default CourseHero;
